import { isExternalPlanInput } from "./externalPlanWorkflow";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Renouvelle l'identité d'idempotence d'une écriture éditoriale externe.
 *
 * V97.215 lie request_id à une tentative atomique. Le réutiliser pour une
 * modification ultérieure ferait rejouer l'ancienne consultation canonique.
 * Les preuves de synthèse et les empreintes restent strictement inchangées.
 */
export function prepareExternalEditorialSave(
  consultation,
  randomUUID = () => globalThis.crypto?.randomUUID?.(),
) {
  const externalInput = consultation?.editorial_overrides?.external_plan_input;
  if (externalInput === null || externalInput === undefined) return consultation;
  if (externalInput?.plan_input_mode !== "external_anonymized_dossier_v1") {
    return consultation;
  }
  // Un mode externe déclaré est aussi reconnu comme externe par la couche
  // de persistance. Son contrat doit donc être complet avant d'atteindre la RPC,
  // sinon un ancien request_id pourrait rejouer une tentative canonique.
  if (!isExternalPlanInput(externalInput)) {
    throw new Error("Preuve externe à valider avant la sauvegarde.");
  }

  const requestId = randomUUID?.();
  if (!UUID_RE.test(requestId || "") || requestId === externalInput.request_id) {
    throw new Error("Nouvelle tentative de sauvegarde externe indisponible.");
  }

  return {
    ...consultation,
    editorial_overrides: {
      ...consultation.editorial_overrides,
      external_plan_input: {
        ...externalInput,
        request_id: requestId,
      },
    },
  };
}

/** Point unique utilisé par toutes les sauvegardes éditoriales de la modale. */
export async function saveEditorialConsultationWithFreshExternalRequest({
  consultation,
  save,
  randomUUID,
}) {
  if (typeof save !== "function") {
    throw new Error("Sauvegarde éditoriale indisponible.");
  }
  const previousExternal = consultation?.editorial_overrides?.external_plan_input;
  const payload = prepareExternalEditorialSave(consultation, randomUUID);
  const externalExpectedRequestId = isExternalPlanInput(previousExternal)
    ? previousExternal.request_id
    : undefined;
  return save(payload, externalExpectedRequestId
    ? { externalExpectedRequestId }
    : undefined);
}
